<template>
  <div id="app">
    <div class="home">
      <Statuses/>
    </div>
  </div>
</template>

<script>
  import Statuses from "@/components/Statuses.vue";

  export default {
    name: "App",
    components: {
      Statuses
    }
  };
</script>

<style lang="less">
#app {
  font-family: 'Inter', serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  height:auto;
}

.home {
  display: inline-block;
  position: relative;
}
</style>
